export const getCsrfToken = () => {
  const cookieRow = document.cookie
    .split("; ")
    .find((row) => row.startsWith("XSRF-TOKEN="));

  return cookieRow ? cookieRow.split("=")[1] : null;
};